var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 70,
    viewBox: "0 0 64 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3838 19.9786C22.9007 19.9786 27.3731 15.5062 27.3731 9.98928C27.3731 4.47235 22.9007 0 17.3838 0C11.8669 0 7.39453 4.47235 7.39453 9.98928C7.39453 15.5062 11.8669 19.9786 17.3838 19.9786Z",
    fill: "url(#paint0_linear_2389_344)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6504 43.4599C31.6491 42.97 34.032 42.5806 34.032 38.7084C34.032 29.5135 26.578 22.0596 17.3832 22.0596C8.18829 22.0596 0.734375 29.5135 0.734375 38.7084C0.734375 47.9032 14.1701 73.2546 17.3832 55.3572C19.2431 44.9969 24.5285 44.1334 28.6504 43.4599Z",
    fill: "url(#paint1_linear_2389_344)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3575 19.9787C42.3575 24.5761 45.8981 28.3031 50.2657 28.3031C54.6332 28.3031 58.1738 24.5761 58.1738 19.9787C58.1738 15.3813 54.6332 11.6543 50.2657 11.6543C45.8981 11.6543 42.3575 15.3813 42.3575 19.9787Z",
    fill: "url(#paint2_linear_2389_344)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6672 47.0885C39.2682 46.6966 37.3619 46.3851 37.3619 43.2872C37.3619 35.9311 43.3251 29.9678 50.681 29.9678C58.0369 29.9678 64 35.9311 64 43.2872C64 50.6433 53.2514 70.925 50.681 56.6066C49.193 48.3182 44.9647 47.6273 41.6672 47.0885Z",
    fill: "url(#paint3_linear_2389_344)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2389_344",
    x1: 1,
    y1: 37.5,
    x2: 64,
    y2: 37.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF3437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B62752"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2389_344",
    x1: 1,
    y1: 37.5,
    x2: 64,
    y2: 37.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF3437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B62752"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2389_344",
    x1: 1,
    y1: 37.5,
    x2: 64,
    y2: 37.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF3437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B62752"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2389_344",
    x1: 1,
    y1: 37.5,
    x2: 64,
    y2: 37.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF3437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B62752"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.c9e06769288fc23ca6354f274c19cd49.svg";
export { ForwardRef as ReactComponent };